"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RibbonType = void 0;
var RibbonType;
(function (RibbonType) {
    RibbonType["REGULAR"] = "regular";
    RibbonType["RECOMMENDED"] = "recommended";
})(RibbonType = exports.RibbonType || (exports.RibbonType = {}));
//# sourceMappingURL=RibbonProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Ribbon/RibbonProps.js
// module id = 1236
// module chunks = 8